import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function UniqueMechanism() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-gradient-to-b from-cream to-white py-16 md:py-24 px-6" data-id="element-164">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.7
    }} className="max-w-4xl mx-auto" data-id="element-165">
        <div className="text-center mb-12" data-id="element-166">
          <SparklesIcon className="w-12 h-12 text-soft-gold mx-auto mb-6" data-id="element-167" />
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-warm-brown mb-6" data-id="element-168">
            El Método que Sí Funciona
          </h2>
          <p className="text-xl md:text-2xl text-terracotta font-semibold" data-id="element-169">
            Terapia de Sueño 7-Min
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl border-t-4 border-soft-gold" data-id="element-170">
          <p className="text-lg md:text-xl text-warm-brown leading-relaxed mb-6" data-id="element-171">
            He creado la <strong data-id="element-172">Terapia de Sueño 7-Min</strong>, basada en la{' '}
            <strong data-id="element-173">Micro-conexión Sensorial</strong>. No es un entrenamiento;
            es una sincronización biológica.
          </p>
          <p className="text-lg md:text-xl text-warm-brown leading-relaxed" data-id="element-174">
            A través del método 1-2-4, utilizamos tu propio sistema nervioso
            para regular el de tu bebé. En lugar de forzar el sueño, construimos
            una "rampa de aterrizaje" de 7 minutos donde usamos el contacto
            visual, el pulso rítmico y el descenso térmico para que el cerebro
            de tu bebé envíe la señal natural de apagado.{' '}
            <strong data-id="element-175">Sin lágrimas, sin trauma, solo conexión.</strong>
          </p>
        </div>
      </motion.div>
    </section>;
}